<div *ngIf="transparent" style="width: 100%; height: 22px;"></div>
<mat-toolbar [class.transparent]="transparent">
    <ng-content></ng-content>
</mat-toolbar>
<div *ngIf="transparent" style="width: 100%; height: 10px; border-bottom: 2px solid #1da97836;"></div>